import { lazy } from 'react';

const BulkFileSharingModal = lazy(() =>
  import('modules/CounselorDashboard/BulkFileSharingModal'),
);

export default {
  BULK_FILE_SHARING_MODAL: BulkFileSharingModal,
};
